import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed';

export default {
  Helmet: lazy(() => import('./Helmet')),
  Comments: lazyNamed(() => import('./pages/Comments'), 'Comments'),
  SystemNotifications: lazy(() => import('./pages/SystemNotifications')),
};
